import React, {
	Component
} from 'react';
import {
	domainUrl
} from '../config/Config';
import {
	getTokenData,
  getUserData
} from '../helpers/Common';
import {
	UserId
} from '../helpers/User';
const $ = window.$;
export default class Dmwall extends Component {
	constructor(props) {
		super(props);
		this.state = {
			groupTopPerformers: [],
			productTopPerformers: [],
			universalTopPerformers: [],
			birthdayList: [],
      buddyAjaxCallCompleted: false
		};
	}
	getWallPerformers() {
		$("#performerLoader").show();
		fetch(domainUrl + "getwall-performers", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({
				learner_id: UserId()
			})
		}).then((response) => response.json()).then((responseJson) => {
			$("#performerLoader").hide();
			if (responseJson.status !== 0) {
				this.setState({
					groupTopPerformers: responseJson.groupTopPerformers,
					productTopPerformers: responseJson.productTopPerformers,
					universalTopPerformers: responseJson.universalTopPerformers
				});
			}
		});
	}
	getWallBuddiesBirthday() {
		$("#birthdayLoader").show();
		fetch(domainUrl + "getwall-birthday", {
			method: "POST",
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json',
				'Authorization': 'Bearer ' + getTokenData()
			},
			body: JSON.stringify({
				learner_id: UserId()
			})
		}).then((response) => response.json()).then((responseJson) => {
			$("#birthdayLoader").hide();
			if (responseJson.status !== 0) {
				this.setState({
					buddyAjaxCallCompleted: true,
					birthdayList: responseJson.birthdayList
				});
			}
		});
	}
	loadWallData() {
		this.getWallPerformers();
		this.getWallBuddiesBirthday();
	}
	componentDidMount() {
		if (this.props.autoload) {
      this.getWallPerformers();
      this.getWallBuddiesBirthday();
    }
		$('.owl-carousel').owlCarousel({
			loop: true,
			items: 3,
			dots: false,
			nav: true,
			margin: 15,
			autoplay: true,
			autoplayTimeout: 3500,
			autoplayHoverPause: true,
			responsive: {
				0: {
					items: 1,
					margin: 0
				},
				640: {
					items: 1,
					margin: 15
				},
				768: {
					items: 3,
					margin: 15
				},
				1024: {
					items: 4
				}
			}
		});
		$(".top-perform h1").attr('style', 'font-family: "Great Vibes", cursive !important');
	}
	render() {
			let d=new Date(), jYear=d.getFullYear();
			const topPerformerHtml1 = this.state.groupTopPerformers.map((val, key)=>{
					return <div className="item">
							<img src={val.photoPath} alt="" />
							{val.name !== '' &&
								<span><p className="performer-name">{val.name}</p>
								<p className="performer-product">{val.product}</p></span>
							}
							{val.name !== '' &&
								<p className="performer-group">GROUP TOP PERFORMER</p>
							}
							{val.name === '' &&
								<p className="performer-group">NO GROUP TOP PERFORMER</p>
							}
							<p className="performer-corporate">{val.corporate}</p>
					</div>
			});

			const topPerformerHtml2 = this.state.productTopPerformers.map((val, key)=>{
					return <div className="item">
							<img src={val.photoPath} alt="" />
							{val.name !== '' &&
								<span><p className="performer-name">{val.name}</p>
								<p className="performer-product">{val.product}</p></span>
							}
							{val.name !== '' &&
								<p className="performer-group">PRODUCT TOP PERFORMER</p>
							}
							{val.name === '' &&
								<p className="performer-group">NO PRODUCT TOP PERFORMER</p>
							}
							<p className="performer-corporate">{val.corporate}</p>
					</div>
			});

			const topPerformerHtml3 = this.state.universalTopPerformers.map((val, key)=>{
					return <div className="item">
							<img src={val.photoPath} alt="" />
							{val.name !== '' &&
								<span><p className="performer-name">{val.name}</p>
								<p className="performer-product">{val.product}</p></span>
							}
							{val.name !== '' &&
								<p className="performer-group">UNIVERSAL TOP PERFORMER</p>
							}
							{val.name === '' &&
								<p className="performer-group">NO UNIVERSAL TOP PERFORMER</p>
							}
							<p className="performer-corporate">{val.corporate}</p>
					</div>
			});

			const birthdayHtml = this.state.birthdayList.map((val, key)=>{
					return <div className="item">
							<img src={val.photoPath} alt="" />
							<p className="performer-name">{val.name}</p>
							<p className="performer-product">{val.email}</p>
					</div>
			});

			return (
					<div className="row">
							<div className="head-pad">
									<div className="logo wall"><img src={process.env.PUBLIC_URL +'/images/logo-361dm-180x62.png'} alt="" /></div>
							</div>
							<div className="top-perform">
									<h1>Top Performers</h1>

									<div className="owl-carousel-wrap">
											<span id="performerLoader" style={{display: "none"}}><img src={process.env.PUBLIC_URL +'/images/loader.gif'} alt="" /></span>
											<div className="owl-carousel">
													{topPerformerHtml1}
													{topPerformerHtml2}
													{topPerformerHtml3}
											</div>
									</div>
									<div className="birthday-today">
											<img src={process.env.PUBLIC_URL +'/images/gift-box.png'} className="gift-box" alt="" />
											<h1>Birthdays Today<span>{getUserData("appFullDate", true)}</span></h1>

											{this.state.buddyAjaxCallCompleted && this.state.birthdayList.length <= 0 &&
													<div className="b-day-not">No buddies found!</div>
											}

											<div className="owl-carousel-wrap">
													<span id="birthdayLoader" style={{display: "none"}}><img src={process.env.PUBLIC_URL +'/images/loader.gif'} alt="" /></span>
													<div className="owl-carousel">
															{birthdayHtml}
													</div>
											</div>
									</div>
							</div>
							<div className="foot-pad"> &copy; {jYear}. www.361DM.com All rights reserved</div>
					</div>
			);
	}
}



// WEBPACK FOOTER //
// ./src/partials/DmWall.js